export default __webpack_public_path__ + "static/media/12.5541325c.PNG";